/**
 * `T-65` · Una sección detrás de **un permiso**, cargada bajo demanda.
 *
 * Hermana de `SeccionDeModulo` y por el mismo motivo: el módulo dice *qué se
 * vendió* y el permiso *quién tiene la llave*. Hasta hoy sólo existía la
 * primera puerta, y `Personal` se montaba para cualquiera.
 *
 * > [!danger] Esto NO protege nada, y confundirlo es cómo se acaba con un panel
 * > que oculta un botón y una API que deja llamarlo
 * > La puerta de verdad es `@Exige` en el servidor, que contesta 403 y no se
 * > puede rodear desde el navegador.
 * >
 * > Lo que esto evita es **montar una pantalla que no puede funcionar**. Sin
 * > ella, una cajera que teclea `/personal` vería la lista pedirse, fallar con
 * > un 403 y pintar un error de red donde tocaba una explicación. Y ya no basta
 * > con que `Armazon` esconda el enlace: esconder el enlace no cierra la URL.
 */
import { Suspense, type ComponentType, type LazyExoticComponent, type ReactNode } from 'react'
import { useOutletContext } from 'react-router'
import { puede, type Yo } from '../api/sesion.js'

export function SeccionConPermiso({ permiso, pantalla: Pantalla }: {
  readonly permiso: string
  readonly pantalla: LazyExoticComponent<ComponentType>
}): ReactNode {
  //  `?? undefined` y no `useOutletContext<Yo>()` a secas: montada suelta en una
  //  prueba no hay `Outlet`, y `puede(undefined, …)` es `false` — lo prudente.
  const yo = useOutletContext<Yo | null>() ?? undefined

  if (!puede(yo, permiso)) {
    //  Qué le falta y a quién pedírselo. «No tienes permiso» a secas deja a una
    //  encargada sin saber si es un fallo del sitio o una decisión de su jefa.
    return (
      <p className="panel-personal__vacio">
        Esta sección la abre quien tenga ese permiso en tu cafetería. Si te hace
        falta, pídeselo a la dueña.
      </p>
    )
  }

  return (
    <Suspense fallback={<p aria-busy="true">Cargando…</p>}>
      <Pantalla />
    </Suspense>
  )
}
